module.exports = __webpack_public_path__ + "static/media/landing-bgImg.53cf49d1.png";